import React, {Component} from "react";
import {FaBars} from "react-icons/fa";
import {AiOutlineClose} from "react-icons/ai";

class Header extends Component {
    render() {
        const {showMenuToggle, showMenu, setDirection} = this.props;
        return (
            <div className="header-container">
                <div className="container-fluid d-flex justify-content-between px-5 py-2">
                    <h3>Aman Gupta</h3>
                    <button className="border-0 bg-transparent" onClick={() => {
                        showMenuToggle(!showMenu);
                        setDirection(showMenu ? "up" : "down")
                    }}>
                        {showMenu ? <AiOutlineClose size={30}/> : <FaBars size={30}/>}
                    </button>
                </div>
            </div>
        )
    }
}

export default Header;